import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SignupForm = () => {
  const [email, setEmail] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");
  const [position, setPosition] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (status === "loading" || status === "success") return;
    setStatus("loading");
    setMessage("");
    try {
      const { data } = await axios.post(`${API}/signups`, {
        email,
        honeypot,
      });
      setPosition(data.position);
      setMessage(data.message);
      setStatus("success");
      setEmail(data.already ? email : "");
    } catch (err) {
      setStatus("error");
      setMessage(
        err?.response?.data?.detail || "Something went wrong. Please try again."
      );
    }
  };

  const success = status === "success";

  return (
    <div className="w-full">
      <motion.form
        onSubmit={onSubmit}
        noValidate
        className="signup-shell mx-auto flex max-w-[570px] flex-col overflow-hidden rounded-[18px] md:flex-row md:rounded-full"
        data-testid="signup-form"
      >
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
          aria-label="Email address"
          autoComplete="email"
          disabled={success}
          className="flex-1 bg-transparent px-6 py-4 md:py-[18px] text-center md:text-left text-[0.85rem] tracking-[0.06em] text-[color:var(--cream)] outline-none disabled:opacity-60"
          data-testid="signup-email-input"
        />
        <input
          type="text"
          name="company_website"
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          className="hidden"
        />
        <motion.button
          type="submit"
          whileTap={{ scale: 0.97 }}
          disabled={success || status === "loading"}
          className="border-0 bg-[color:var(--matte-brown)] px-8 py-4 text-[0.66rem] tracking-[0.25em] uppercase text-[#ead8ca] transition-colors duration-300 hover:bg-[color:var(--champagne)] hover:text-[color:var(--espresso)] disabled:cursor-default disabled:hover:bg-[color:var(--matte-brown)] disabled:hover:text-[#ead8ca]"
          data-testid="signup-submit-button"
        >
          {status === "loading"
            ? "Joining…"
            : success
              ? "You're On The List"
              : "Join The List"}
        </motion.button>
      </motion.form>
      <p
        className="mt-3 min-h-[1em] text-[0.68rem] tracking-[0.08em] text-[color:var(--champagne)]"
        aria-live="polite"
        data-testid="signup-message"
      >
        {message}
        {success && position ? ` — #${position} on the private list` : ""}
      </p>
    </div>
  );
};

export default SignupForm;
